import React, { Component } from 'react';
import ReactCardCarousel from 'react-card-carousel';
import '../css/AboutUs.css';
import aboutUs1 from '../images/aboutUs1.jpg';
import aboutUs2 from '../images/aboutUs2.jpg';
import aboutUs3 from '../images/aboutUs3.jpg';
import aboutUs4 from '../images/aboutUs4.jpg';
import aboutUs5 from '../images/aboutUs5.jpg';


class AboutUs extends Component {

  render() {
    return (
    <div className="aboutUs container">
      <h1>About Us<span>.</span></h1>
      <div className="row">
        <div className="col-lg-5 col-md-12 col-12 m-auto">
          <p className="text-justify">
            &emsp;IKAEMERCE merupakan sebuah web yang dibuat dengan tujuan untuk menjadi contoh website ecommerce sederhana,
            lebih ke landing page yang nantinya setiap proses transaksi akan langsung di redirect ke marketplace seperti:
            <br></br>&emsp; <i className="fa fa-check-square-o" aria-hidden="true"></i> Tokopedia
            <br></br>&emsp; <i className="fa fa-check-square-o" aria-hidden="true"></i> Shopee
            <br></br>&emsp; <i className="fa fa-check-square-o" aria-hidden="true"></i> Bukalapak
            <br></br>
            Sehingga proses transaksi menjadi lebih aman dan terpercaya. Pelanggan senang, penjual pun ikut senang.
          </p>
        </div>
        <div className="col-lg-7 col-md-12 col-10 mx-auto">
          <ReactCardCarousel autoplay={ true } autoplay_speed={ 10000 }>
            <div className="cardStyle">
              <img src={aboutUs1} className="img-fluid" alt=""/>
            </div>
            <div className="cardStyle">
              <img src={aboutUs2} className="img-fluid" alt=""/>
            </div>
            <div className="cardStyle">
              <img src={aboutUs3} className="img-fluid" alt=""/>
            </div>
            <div className="cardStyle">
              <img src={aboutUs4} className="img-fluid" alt=""/>
            </div>
            <div className="cardStyle">
              <img src={aboutUs5} className="img-fluid" alt=""/>
            </div>
          </ReactCardCarousel>
        </div>
      </div>
    </div>
    );
  }
}

export default AboutUs;
